import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000, // increased for file uploads
});

// Attach JWT to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally - redirect to login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/login', credentials),
};

export const customerAPI = {
  search: (q) => api.get('/customers/search', { params: { q } }),
  getById: (id) => api.get(`/customers/${id}`),
};

export const serviceAPI = {
  getByMembership: (membershipNo) => api.get(`/customer/services/${membershipNo}`),
  claimServices: (payload) => api.post('/services/claim', payload),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
};

export const uploadAPI = {
  uploadExcel: (file, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/excel', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
  },
};

export default api;